import 'polyfills';

import { RuntimeType } from '@nizza/core';
import { initializeNizzaRuntime, registerReactComponent } from '@nizza/utils';
import { App } from 'app';
import { Amplify } from 'aws-amplify';
import env from '~env';
import logger from '~logger';
import './locales';
import { AMPLIFY } from './shared';

const ROOT_ID = 'nz-backoffice-front';
const runtime = initializeNizzaRuntime({ env, logger });

Amplify.configure({ Auth: AMPLIFY.auth });

registerReactComponent(runtime, ROOT_ID, [App]);

runtime.config(RuntimeType.Platform, async (config) => {
  const { component } = config;
  await component.render();
});

runtime.execute();
